import stylePagination from "./Pagination.module.css";
export const RowsPerPageSelect = ({ value, onChange, pageSizeOptions }) => {
  return (
    <select 
      value={value}
      onChange={onChange}
      className={`${stylePagination["btn-perPage"]} border-1 w-16 rounded-xl border-[#1F316F] focus:border-0`}

    >
      {pageSizeOptions.map((size) => (
        <option key={size} value={size}>
          {size}
        </option>
      ))}
    </select>
  );
};
